export const SET_QUESTIONNAIRE = "SET_QUESTIONNAIRE";
export const SET_INVITE_ID = "SET_INVITE_ID";
export const SET_FOR_GO = "SET_FOR_GO";
export const SET_SURVEY_STATUS = "SET_SURVEY_STATUS";
export const SET_START_TIME = "SET_START_TIME";
export const SET_SURVEY_MESSAGE = "SET_SURVEY_MESSAGE";
export const GET_WEB_SURVEY = "GET_WEB_SURVEY";
export const GET_DIVISIONS = "GET_DIVISIONS";
export const SET_DIVISION_INFO = "SET_DIVISION_INFO";
export const SET_SURVEY_SCORE = "SET_SURVEY_SCORE";
export const STORE_ITEMS = "STORE_ITEMS";
export const HIDE_ITEM_LIST = "HIDE_ITEM_LIST";
export const SET_LINKED_OPTION_FOR_ITEM = "SET_LINKED_OPTION_FOR_ITEM";
export const REMOVE_LINKED_OPTION = "REMOVE_LINKED_OPTION";
export const SET_PREVIOUS_RESPONSE = "SET_PREVIOUS_RESPONSE";
export const SET_QUIZ_FLAG = "SET_QUIZ_FLAG";
export const SET_QUIZ_SCORE = "SET_QUIZ_SCORE";
export const SET_IS_DEMO = "SET_IS_DEMO";
export const SET_AUTO_START = "SET_AUTO_START";
export const SET_STAGE_NUMBER = "SET_STAGE_NUMBER";
export const SET_LAST_FEEDBACK_ID = "SET_LAST_FEEDBACK_ID";
export const SET_PREVIOUS_STAGES_RESPONSE = "SET_PREVIOUS_STAGES_RESPONSE";
export const SET_SURVEY_FIELDS = "SET_SURVEY_FIELDS";
export const SET_PREVENT_ID = "SET_PREVENT_ID";
export const SET_IS_APP_EMBED = "SET_IS_APP_EMBED";
export const GET_DIVISION_FOR_EMBED_SURVEY = "GET_DIVISION_FOR_EMBED_SURVEY";
export const POST_SURVEY_OPEN_SIGNAL = "POST_SURVEY_OPEN_SIGNAL";
export const SET_SUBMITTED_BY = "SET_SUBMITTED_BY";
